import { TABS_CONFIG } from '../constants/tabConfig';
import { BucketProps } from '../pages/home/containers/BucketContainer/BucketContainer';

export function formatBucketLabelFromKey({
    bucketKey,
    tabKey,
    name,
    currentPlace,
}: Pick<BucketProps, 'bucketKey' | 'tabKey' | 'name' | 'currentPlace'>) {
    if (!!name && bucketKey === 'primary_bucket')
        return `Events in ${currentPlace}`;
    if (!!name && bucketKey === 'secondary_bucket')
        return `${name.toString()} in ${currentPlace}`;
    if (!!bucketKey && bucketKey !== 'primary_bucket')
        return bucketKey.replaceAll('_', ' ').toLowerCase();
    if (!!tabKey && tabKey.length) return TABS_CONFIG[tabKey].name;
    return null;
}
